import './src/styles/font-awesome.min.css'
import './src/styles/animate.css'
import './src/styles/icofonts.css'
import './src/styles/bootstrap.min.css'
import './src/styles/owlcarousel.min.css'
import './src/styles/magnific-popup.css'
import './src/styles/style.css'
import './src/styles/responsive.css'

